import { render, staticRenderFns } from "./LandingTitleExtended.vue?vue&type=template&id=006c1d6a&scoped=true"
import script from "./LandingTitleExtended.vue?vue&type=script&lang=js"
export * from "./LandingTitleExtended.vue?vue&type=script&lang=js"
import style0 from "./LandingTitleExtended.vue?vue&type=style&index=0&id=006c1d6a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c1d6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006c1d6a')) {
      api.createRecord('006c1d6a', component.options)
    } else {
      api.reload('006c1d6a', component.options)
    }
    module.hot.accept("./LandingTitleExtended.vue?vue&type=template&id=006c1d6a&scoped=true", function () {
      api.rerender('006c1d6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/Landing/components/LandingTitleExtended.vue"
export default component.exports